<template>
  <div>Visitas Domiciliares</div>
</template>

<script>
export default {}
</script>

<style></style>
